import {useEffect, useState, useRef, useContext} from "react";
import {useHistory} from "react-router-dom";
import {vdomain} from "commons/config";

import style from "./style.module.scss";
import {HiSearch} from "react-icons/hi";

import Select from "./Components/Select";

import {langContext} from "commons/contexts";
import {translateType} from "commons/utils";


let animIndx = 2;

type textType = Record<string, Record<string, string>>;

const textsLang: textType = {
    nl: {
        searchbarTitle: "SEARCH PROPERTIES",
        reference: "Referentie",

        type: "Type",
        region: "Regio",
        location: "Locatie",
        chooseRegion: "Kies eerst de regio",
        bedrooms: "Slaapkamers",
        priceFrom: "Prijs vanaf",
        priceTo: "Prijs tot"

    },
    fr: {
        searchbarTitle: "RECHERCHER DES PROPRIETES",
        reference: "Référence",

        type: "Type",
        region: "Région",
        location: "Localité",
        chooseRegion: "Choisissez d'abord une région",
        bedrooms: "Chambres",
        priceFrom: "Prix à partir de",
        priceTo: "Prix jusqu'à"

    },
};

interface props {
    text: Record<string, string[]>;
    short?: boolean;
    search?: boolean;
}
function WelcomePage({text, short, search}: props) {
    const [rawOptions, setRawOptions] = useState<Record<string, any> | null>(null);

    const history = useHistory();

    const {lang, setLang, langs} = useContext(langContext);

    const uiText = textsLang[lang];

    const bgImagesCnt = useRef<HTMLDivElement>(null);

    const bgImages = ["/media/images/gentleslide/1.jpg", "/media/images/gentleslide/2.jpg", "/media/images/gentleslide/3.jpg"]

    useEffect(() => {
        const changeImage = () => {
            const bgCnt: HTMLDivElement = bgImagesCnt.current!;

            if (!bgCnt) return;
            const bgImages = [...bgCnt.children].slice(0, -1);

            animIndx = (animIndx + 1) % bgImages.length;

            const prevIndx = (animIndx + bgImages.length - 1) % bgImages.length;

            console.log(prevIndx, animIndx);

            bgImages[prevIndx].classList.add(style.fadeOut);
            bgImages[animIndx].classList.remove(style.fadeOut);

        }

        changeImage();
        setInterval(changeImage, 12 * 1000);
    }, []);


    const optionsTops: {[key: string]: string[]} = {
        type: [uiText?.type || ""],
        region: [uiText?.region || ""],
        location: [uiText?.location || "", uiText?.chooseRegion || ""],
        bedrooms: [uiText?.bedrooms || ""],
        from: [uiText?.priceFrom || ""],
        to: [uiText?.priceTo || ""]
    };


    type chosensInterface = Record<string, any>;

    const [options, setOptions] = useState(optionsTops);
    const [chosens, setChosens] = useState<chosensInterface>({});

    useEffect(() => {
        fetch(vdomain + "/int-getSearchOptions").then(response => {
            response.json().then(json => {
                let ops = {...optionsTops};
                ops.type = [...ops.type, ...json?.types];

                let region = Object.keys(json?.regions);
                ops.region = [...ops.region, ...region];

                ops.bedrooms = [...ops.bedrooms, ...json?.bedrooms];


                let prices = getPrices(json.prices);
                ops.from = [optionsTops.from[0], ...prices];
                ops.to = [optionsTops.to[0], ...prices];

                setOptions(ops);
                setRawOptions(json);
            });
        });

        //eslint-disable-next-line
    }, [lang]);

    function getPrices(prices: Record<string, number>): string[] {

        var pric = prices.from;
        var newpricelist = [];

        if (pric !== prices.to) {

            const formatter = new Intl.NumberFormat("en-us", {style: "decimal"});
            const monetize = (mn: number) => formatter.format(mn) + " €";

            var pricestep = 100000;
            var pricTo = 1000000;

            while (pric + pricestep <= pricTo) {
                newpricelist.push(monetize(pric));
                pric += pricestep;
            }

            pricestep = 1000000;
            pric = 1000000;
            while (pric + pricestep < prices.to) {
                newpricelist.push(monetize(pric));
                pric += pricestep;
            }
            newpricelist.push(monetize(prices.to));
        }


        return newpricelist;
    }

    useEffect(() => {
        console.log("CHOSENS", chosens);
        if (chosens.region) {
            setOptions({...options, location: [optionsTops.location[0], ...rawOptions!.regions[chosens.region]]});
        }
        //eslint-disable-next-line
    }, [chosens.region]);

    function startSearch() {
        let params: chosensInterface = {};
        params.ref = chosens.ref || "";
        params.type = chosens.type || "";
        params.region = chosens.region || "";
        params.location = chosens.location || "";
        params.bedrooms = chosens.bedrooms || "";
        params.from = chosens.from || "";
        params.to = chosens.to || "";

        history.push("/" + lang + "/results?" + (new URLSearchParams(params)).toString());

    }

    return (

        <div className={style.root}>

            {search && <div className={style.langCnt}>
                {langs.map((lan: string) =>
                    <div
                        className={style.langItem} key={lan}
                        style={{backgroundColor: ((lan === lang) ? "#9af6" : "unset")}}
                        onClick={() => setLang(lan)}>
                        <div>{lan}</div>
                    </div>
                )}
            </div>
            }

            {
                search ?
                    <div className={style.background}>
                        <div className={style.filter} />
                        <video src="/media/videos/welcome.mp4" autoPlay loop muted playsInline className={style.video} />
                    </div>
                    :
                    <div className={style.bgImagesCnt} ref={bgImagesCnt}>
                        {bgImages.map((img, i) => <div className={style.bgImg + " " + ((i !== animIndx) ? style.fadeOut : "")} key={i} style={{backgroundImage: `url("${img}")`}} />)}
                        <div className={style.bgFilter} />
                    </div>
            }

            <div className={style.topText}>
                <div>{text.topText && text.topText[0]}</div>
                <div>{text.topText && text.topText[1]}</div>
                <div>{text.topText && text.topText[2]}</div>
            </div>

            <div className={style.middleContainer}>
                <div className={style.middleText}>
                    <div>{text.middleText && text.middleText[0]}</div>
                    <div className={short ? style.middleTitleShort : ""} >{text.middleText && text.middleText[1]}</div>
                    <div>{text.middleText && text.middleText[2]}</div>
                </div>
            </div>

            {
                search && <div className={style.searchArea}>
                    <div>{uiText?.searchbarTitle || ""}</div>
                    <div className={style.searchFormCnt}>
                        <div>
                            <input className={style.refInput} placeholder={uiText?.reference || ""} onChange={e => setChosens({...chosens, ref: e.target.value})} />
                        </div>
                        {Object.keys(options).map(
                            key => {
                                let ops = options;
                                if (key === "type") {
                                    ops = {...options}
                                    ops[key] = ops[key].map((op, i) => ((i !== 0) ? translateType(op, lang) : op));
                                }

                                return <div key={key}>
                                    <Select options={ops[key]} locationFirst={ops.location[0]} param={key} chosenState={{chosens, setChosens}} />
                                </div>
                            }
                        )}
                        <div className={style.searchButton} onClick={startSearch}>
                            <HiSearch size="33" />
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default WelcomePage;